import { render, staticRenderFns } from "./DefaultDialog.vue?vue&type=template&id=481dd280&scoped=true"
import script from "./DefaultDialog.vue?vue&type=script&lang=js"
export * from "./DefaultDialog.vue?vue&type=script&lang=js"
import style0 from "./DefaultDialog.vue?vue&type=style&index=0&id=481dd280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481dd280",
  null
  
)

export default component.exports